import { Checkbox } from '@heroui/react';
import type { SelectOption } from './SimpleSelect';

// 多选控件:HeroUI Select 不支持多选受控,选项少的场景用 Checkbox 组平铺
// 受控值为 string[],语义与 TDesign 多选 Select 一致
export function SimpleMultiSelect({
  value,
  onChange,
  options,
  className,
  isDisabled,
}: {
  value: string[];
  onChange: (value: string[]) => void;
  options: SelectOption[];
  className?: string;
  isDisabled?: boolean;
}) {
  const toggle = (optValue: string, on: boolean) => {
    const set = new Set(value);
    if (on) {
      set.add(optValue);
    } else {
      set.delete(optValue);
    }
    // 按 options 顺序输出,保持稳定
    onChange(options.filter((o) => set.has(o.value)).map((o) => o.value));
  };
  return (
    <div className={`flex flex-wrap gap-x-4 gap-y-2 ${className ?? ''}`}>
      {options.map((opt) => (
        <Checkbox
          key={opt.value}
          isSelected={value.includes(opt.value)}
          isDisabled={isDisabled}
          onChange={(on) => toggle(opt.value, on)}
        >
          <Checkbox.Content>
            <Checkbox.Control>
              <Checkbox.Indicator />
            </Checkbox.Control>
            {opt.label}
          </Checkbox.Content>
        </Checkbox>
      ))}
    </div>
  );
}
